import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

const CharacterCountGroup = styled(Group)`
  margin-top: ${rem(4)};
`

const CharacterCountText = styled(Caption)`
  color: ${props => props.theme.palette.messaging.critical.normalForeground};
`

interface Props {
  characterCount: number
  maxLength: number
}

export default function CharacterLimitWarning({ characterCount, maxLength }: Props) {
  const intl = useIntl()

  return (
    <CharacterCountGroup direction="horizontal" gap={8} verticalAlign="center" horizontalAlign="space-between">
      <CharacterCountText variant="small">
        {intl.formatMessage({ id: '5jOkGOnvjo', defaultMessage: 'Character limit reached', description: 'Warning notification text when character limit is reached' })}
      </CharacterCountText>
      <CharacterCountText variant="small">
        {intl.formatMessage(
          {
            id: '7rKHv3ICkl',
            defaultMessage: '{characterCount} / {maxLength}',
            description: 'Character count display showing current count out of maximum allowed',
          },
          { characterCount, maxLength },
        )}
      </CharacterCountText>
    </CharacterCountGroup>
  )
}
